import { sva } from "@stubhub/broadway-foundation/css";

export type AnimationState = "hidden" | "entering" | "exiting";

export const welcomeBannerRecipe = sva({
  slots: ["wrapper", "container", "content"],
  className: "welcomeBanner",
  base: {
    wrapper: {
      position: "absolute",
      overflowX: "hidden",
      overflowY: "hidden",
      width: "full",
      height: "primitives.600",
      tablet: {
        height: "primitives.700",
      },
    },
    container: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "bg.fill.brand",
      position: "absolute",
      zIndex: "base",
      width: "full",
      paddingBlock: "primitives.100",
      paddingInline: "primitives.0",
      tablet: {
        paddingBlock: "primitives.150",
      },

      // Initial state: off-screen above
      transform: "translateY(-100%)",

      '&[data-state="entering"]': {
        transform: "translateY(0)",
        transitionProperty: "[transform]",
        transitionDuration: "entrance.emphasized",
        transitionTimingFunction: "entrance",
        _motionReduce: {
          transitionDuration: "instant",
        },
      },

      '&[data-state="exiting"]': {
        transform: "translateY(-100%)",
        transitionProperty: "[transform]",
        transitionDuration: "exit.emphasized",
        transitionTimingFunction: "exit",
        _motionReduce: {
          transitionDuration: "instant",
        },
      },
    },
    content: {
      color: "text.onDark",
      width: "full",
      maxWidth: "[1200px]",
      marginInline: "auto",
      whiteSpace: "nowrap",
      textStyle: "header.medium",
      paddingInlineStart: "primitives.250",
      tablet: {
        paddingInlineStart: "primitives.0",
      },

      // Initial state: off-screen left, invisible
      opacity: "[0]",
      transform: "translateX(-20%)",

      '&[data-state="entering"]': {
        opacity: "[1]",
        transform: "translateX(0)",
        transitionProperty: "[transform, opacity]",
        transitionDuration: "entrance.emphasized",
        transitionTimingFunction: "entrance",
        _motionReduce: {
          transitionDuration: "instant",
        },
      },

      '&[data-state="exiting"]': {
        opacity: "[0]",
        transform: "translateX(50%)",
        width: "primitives.0",
        transitionProperty: "[transform, opacity, width]",
        transitionDuration: "exit.emphasized",
        transitionTimingFunction: "exit",
        _motionReduce: {
          transitionDuration: "instant",
        },
      },
    },
  },
});

export const bannerStyles = welcomeBannerRecipe();
